<template>
    <div class="slide">
        <div class="d-flex justify-content-end">
            <div class="more with-hand align-items-center d-flex" @click="setTempSelect">
                {{ $t("all") }}
                <iconSymbol name="arrow-right-black" width="16" height="16" />
            </div>
        </div>

        <div class="slide-box">
            <div class="slide-icon slide-icon-prev" @click="slideChange('prev')" :class="{ disabled: state.page === 1 }">
                <img src="@/home/assets/img/prev.png" alt="" />
            </div>
            <div class="slide-wrap">
                <div class="slide-icon slide-icon-prev-mobile" @click="slideChange('prev')" :class="{ disabled: state.page === 1 }">
                    <iconSymbol width="20" height="20" name="left-arrow" />
                </div>
                <div class="slide-group-parent">
                    <div class="slide-group" :style="state.slideStyle">
                        <div class="slide-item with-hand" v-for="(i, index) in selfTagList" :key="i.id + index" @click="setCollectionId(i.tag_id)">
                            <div class="inline-block position-relative">
                                <img :src="i.show_photo" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="slide-icon slide-icon-next-mobile" @click="slideChange('next')" :class="{ disabled: !state.nextShow }">
                    <iconSymbol width="20" height="20" name="right-arrow" />
                </div>
            </div>
            <div class="slide-icon slide-icon-next" @click="slideChange('next')" :class="{ disabled: !state.nextShow }">
                <img src="@/home/assets/img/next.png" alt="" />
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Vue, Watch } from "vue-property-decorator";

    @Component({})
    export default class tplCollection extends Vue {
        state: {
            slideStyle: {
                [index: string]: any;
            };
            page: number;
            nextShow: boolean;
            pageSize: number;
        } = {
            slideStyle: {},
            page: 1,
            nextShow: true,
            pageSize: 0,
        };
        time = NaN;
        get tagList() {
            return this.$store.state.tagList;
        }
        selfTagList = [];
        setLimit() {
            if (window.innerWidth <= 768) {
                this.state.pageSize = 1;
            } else if (window.innerWidth <= 1000) {
                this.state.pageSize = 2;
            } else if (window.innerWidth <= 1200) {
                this.state.pageSize = 3;
            } else if (window.innerWidth <= 1920) {
                this.state.pageSize = 4;
            } else if (window.innerWidth <= 2560) {
                this.state.pageSize = 6;
            } else if (window.innerWidth <= 2880) {
                this.state.pageSize = 7;
            } else if (window.innerWidth <= 3200) {
                this.state.pageSize = 8;
            } else if (window.innerWidth <= 3520) {
                this.state.pageSize = 9;
            } else {
                this.state.pageSize = 10;
            }
            if (this.state.page * this.state.pageSize >= this.selfTagList.length) {
                this.state.nextShow = false;
            } else {
                this.state.nextShow = true;
            }
        }
        slideNext() {
            const slide = document.querySelector(".slide-group-parent");
            this.state.page++;
            this.state.slideStyle = {
                transform: `translate3d(-${(this.state.page - 1) * parseInt(getComputedStyle(slide).width)}px , 0 ,0)`,
            };
            this.setLimit();
        }
        slidePrev() {
            const slide = document.querySelector(".slide-group-parent");
            this.state.page--;
            this.state.slideStyle = {
                transform: `translate3d(-${(this.state.page - 1) * parseInt(getComputedStyle(slide).width)}px, 0 ,0)`,
            };
            this.setLimit();
        }
        appendData() {
            const len = this.tagList.length;
            const num = len % this.state.pageSize;
            if (!num) {
                this.selfTagList = [...this.tagList];
                return;
            }
            const left = this.state.pageSize - num;
            const arr = this.tagList.slice(len - num - left, len - num);
            this.selfTagList = this.tagList.concat(arr);
        }

        resize() {
            this.state.page = 1;
            this.state.slideStyle = {};
            this.setLimit();
            this.appendData();
        }
        @Watch("tagList", { deep: true })
        changeLang() {
            this.resize();
        }
        setTime() {
            clearInterval(this.time);
            this.time = setInterval(() => {
                if (this.state.page * this.state.pageSize >= this.selfTagList.length) {
                    this.state.slideStyle = {
                        transform: "translate3d(0, 0 ,0)",
                    };
                    this.state.page = 1;
                    this.setLimit();
                } else {
                    this.slideNext();
                }
            }, 5000);
        }
        slideChange(type: string) {
            this.setTime();
            if (type === "prev") {
                this.slidePrev();
            } else {
                this.slideNext();
            }
        }
        async mounted() {
            this.selfTagList = [...this.tagList];
            this.setTime();
            this.setLimit();
            this.appendData();
            window.addEventListener("resize", this.resize);
        }

        beforeDestroy() {
            clearInterval(this.time);
            window.removeEventListener("resize", this.resize);
        }
        setTempSelect() {
            if (!this.$validateLogin()) return;
            this.$store.commit("setState", {
                type: "templateSelect",
                data: "tags",
            });
        }
        setCollectionId(data: number) {
            if (!this.$validateLogin()) return;
            this.$store.commit("setState", {
                type: "templateSelect",
                data: "tagInfo",
            });
            this.$store.commit("setState", {
                type: "tagId",
                data,
            });
            this.$store.commit("setState", {
                type: "fromAllTags",
                data: false,
            });
        }
    }
</script>

<style lang="less" scoped>
    .slide {
        user-select: none;
        margin: 0 auto;
        margin-top: 42px;
        width: calc(100% - 190px);
        @media screen and (max-width: 1280px) {
            margin-top: 32px;
        }
        @media screen and (max-width: 1920px) {
            width: calc(100% - 278px);
        }
        @media screen and (max-width: 1600px) {
            width: calc(100% - 168px);
        }
        @media screen and (max-width: 1366px) {
            width: calc(100% - 114px);
        }
        @media screen and (max-width: 1200px) {
            width: calc(100% - 80px);
        }

        @media screen and (max-width: 768px) {
            width: calc(100% - 218px);
        }
        position: relative;
        .more {
            font-size: 16px;
            line-height: 28px;
            color: #000000;
            margin-bottom: 18px;
            svg {
                margin-left: 8px;
            }
            @media screen and (max-width: 1280px) {
                svg {
                    margin-left: 2px;
                }
                font-size: 14px;
                margin-bottom: 8px;
            }
        }
        .slide-wrap {
            overflow: hidden;
            @media screen and (max-width: 1200px) {
                display: flex;
                align-items: center;
            }
        }
        .slide-box {
            position: relative;

            .slide-icon-prev {
                position: absolute;
                left: -24px;
                top: 50%;
                background: #ffffff;
                border-radius: 42px;
                width: 54px;
                height: 54px;
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translate(-100%, -50%);
                cursor: pointer;
                svg {
                    width: 7px;
                    height: 13px;
                }
                &.disabled {
                    pointer-events: none;
                    opacity: 0.4;
                }
                @media screen and (max-width: 1600px) {
                    width: 36px;
                    height: 36px;
                    left: -16px;
                }
                @media screen and (max-width: 1200px) {
                    display: none;
                }
            }
            .slide-icon-next {
                position: absolute;
                right: -24px;
                top: 50%;
                background: #ffffff;
                border-radius: 42px;
                width: 54px;
                height: 54px;
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translate(100%, -50%);
                cursor: pointer;
                svg {
                    width: 7px;
                    height: 13px;
                }
                @media screen and (max-width: 1600px) {
                    width: 36px;
                    height: 36px;
                    right: -16px;
                }
                &.disabled {
                    pointer-events: none;
                    opacity: 0.4;
                }
                @media screen and (max-width: 1200px) {
                    display: none;
                }
            }

            .slide-icon-prev-mobile {
                display: none;
                padding-right: 10px;
                @media screen and (max-width: 1200px) {
                    display: block;
                }
                &.disabled {
                    pointer-events: none;
                    opacity: 0.4;
                }
            }
            .slide-icon-next-mobile {
                padding-left: 10px;
                display: none;
                @media screen and (max-width: 1200px) {
                    display: block;
                }
                &.disabled {
                    pointer-events: none;
                    opacity: 0.4;
                }
            }
        }
        .slide-group-parent {
            overflow: hidden;
        }
        .slide-group {
            display: flex;
            transition: 0.3s transform;
            .slide-item {
                .texts {
                    word-wrap: break-word;
                    word-break: normal;
                    position: absolute;
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 32px;
                    text-align: left;
                    transform: translateY(-50%);
                    top: 50%;
                    left: 24px;
                    color: #000000;
                    max-width: 120px;
                }
                img {
                    display: block;
                }
            }

            @media screen and (max-width: 3840px) {
                & > div.slide-item {
                    flex: 0 0 9.550561797752809%;
                    max-width: 9.550561797752809%;
                    margin-right: 0.4993757802746567%;
                    img {
                        width: 100%;
                    }
                }
                & > div:nth-child(10n + 10) {
                    margin-right: 0;
                }
            }
            @media screen and (max-width: 3520px) {
                & > div.slide-item {
                    flex: 0 0 10.897435897435898%;
                    max-width: 10.897435897435898%;
                    margin-right: 0.24038461538461453%;
                    img {
                        width: 100%;
                    }
                }
                & > div:nth-child(9n + 9) {
                    margin-right: 0;
                }
            }
            @media screen and (max-width: 3200px) {
                & > div.slide-item {
                    flex: 0 0 12.142857142857143%;
                    max-width: 12.142857142857143%;
                    margin-right: 0.4081632653061226%;
                    img {
                        width: 100%;
                    }
                }
                & > div:nth-child(8n + 8) {
                    margin-right: 0;
                }
            }
            @media screen and (max-width: 2880px) {
                & > div.slide-item {
                    flex: 0 0 13.709677419354838%;
                    max-width: 13.709677419354838%;
                    margin-right: 0.6720430107526894%;
                    img {
                        width: 100%;
                    }
                }
                & > div:nth-child(7n + 7) {
                    margin-right: 0;
                }
            }
            @media screen and (max-width: 2560px) {
                & > div.slide-item {
                    flex: 0 0 15.74074074074074%;
                    max-width: 15.74074074074074%;
                    margin-right: 1.1111111111111117%;
                    img {
                        width: 100%;
                    }
                }
                & > div:nth-child(6n + 6) {
                    margin-right: 0;
                }
            }
            @media screen and (max-width: 1920px) {
                & > div.slide-item {
                    flex: 0 0 23.743016759776536%;
                    max-width: 23.743016759776536%;
                    img {
                        width: 100%;
                    }
                    margin-right: 1.675977653631285%;
                }

                & > div:nth-child(4n + 4) {
                    margin-right: 0;
                }
            }
            @media screen and (max-width: 1200px) {
                & > div.slide-item {
                    flex: 0 0 31.835205992509363%;
                    max-width: 31.835205992509363%;
                    img {
                        width: 100%;
                    }
                    margin-right: 2.247191011235955%;
                }

                & > div:nth-child(3n + 3) {
                    margin-right: 0;
                }
            }
            @media screen and (max-width: 1000px) {
                & > div.slide-item {
                    flex: 0 0 48.295454545454547%;
                    max-width: 48.295454545454547%;
                    img {
                        width: 100%;
                    }
                    margin-right: 3.409090909090906%;
                }

                & > div:nth-child(2n + 2) {
                    margin-right: 0;
                }
            }
            @media screen and (max-width: 768px) {
                & > div.slide-item {
                    flex: 0 0 100%;
                    max-width: 100%;
                    img {
                        width: 100%;
                    }
                    margin-right: 0 !important;
                }
            }
        }
    }
</style>
<i18n>
{
  "zh": {
    "all": "所有类别"
  },
  "en": {
    "all": "All Collections"
  },
  "jp": {
    "all": "すべてのカテゴリ"
  },
  "fr": {
    "all": "Toutes les Collections"
  },
  "de": {
    "all": "Alle Sammlungen"
  },
  "es": {
    "all": "Todas las Colecciones"
  },
  "pt": {
    "all": "Todas as coleções"
  },
  "it": {
    "all": "Tutte le Collezioni"
  },
  "tw": {
    "all": "所有類別"
  },
  "kr": {
    "all": "모든 컬랙션"
  },
  "id": {
    "all": "Semua Koleksi"
  }
}
</i18n>
